import hljs from 'highlight.js';
import 'highlight.js/scss/github.scss';
import mermaid from 'mermaid/dist/mermaid.esm.min.mjs';

hljs.highlightAll();
mermaid.initialize({ startOnLoad: true });
